import { reauthenticateWithCredential } from 'firebase/auth';
import React,{useState,useEffect} from 'react'
import {getAuth, signOut, updateEmail, updateProfile, EmailAuthProvider} from 'firebase/auth';
import './css/ReAuthenticatePopup.css'




function ReAuthenticatePopup(props) {
     const auth = getAuth();
     const user = auth.currentUser;
     const [password,setPassword] = useState('');
     const [loading,setLoading] = useState(false);
     const [finishScreen,setFinishScreen] = useState(false);
     const [wrongPassword, setWrongPassword] = useState(false);
     
     const changeEmail = () => {
          setLoading(true);
          var cred = EmailAuthProvider.credential(user.email,password);
          reauthenticateWithCredential(user,cred)
          .then(() =>{
               
               updateEmail(user,props.email)   
               .then(() => {
                    console.log("new email: ", user.email);
                    setLoading(false);
                    setFinishScreen(true);
               }).catch((error) => {
                    console.log(error);
               });

          }).catch((error)=>{
               setLoading(false);
               console.log(error);
               setWrongPassword(true);
               setPassword('');
          })
     }


     const close = (event) => {  
          event.preventDefault();
          if(event.target === event.currentTarget) {
               setFinishScreen(false);
               //close the whole popup with the function() in the parent
               props.setShowReLoginAuthPopup(false);
          }        
     }



     return (
          <div className='reAuthenticatePopupWide' onClick={close}> 
               <div className='container'>
               
               {loading &&
                    <div className='loading'></div>
               }


               {finishScreen &&
                   <div className='finishScreen'>
                         <div className='center'>
                              <p>Your email has been changed to <span>{user.email}</span></p>
                              <button onClick={close}>Close</button>
                         </div>
                    </div> 
               }


                    <p>Changing this email may just be the most important thing you ever do, so we need to be sure it's you.</p>
                    <input type='password' value={password} 
                         placeholder={ wrongPassword ? "Wrong Password" : "Enter your password"}
                         className={wrongPassword ? 'wrongPassword' : 'textfield'}
                         onChange = {(event) => setPassword(event.target.value)} 
                         onFocus = { () => { setWrongPassword(false) }}
                    />
                    <div>
                         <button className='changeEmailButton' onClick={changeEmail}>Change Email</button>
                    </div>
               </div>
          </div>
               
    
     )
}

export default ReAuthenticatePopup
